export const MFA_SESSION_LABELS_LABELS = {
	POPUP_TITLE: 'Session labels'
};
